import React, {useState} from 'react';
import LanguageImageSrc from '../../assets/Images/language.png';
import {SelectLngInput} from './language-menu.styles';
import i18n from '../../services/i18n';
import i18next from "i18next";
import {useTranslation} from "react-i18next";

const LanguageMenu = () => {

    const [activeLng, setActiveLng] = useState(i18next.language || localStorage.i18nextLng);

    const [t] = useTranslation();

    const changeLanguage = async ({target: {value}}) => {
        try {
            await i18n.changeLanguage(value);
            setActiveLng(i18next.language)
        } catch (e) {

        }
    }

    return (
        <div>
            <img className='w-100' src={LanguageImageSrc} alt='language' />
            <div className='mt-3'>
                <p className='lng-text'>{t('select lng')}</p>
                <SelectLngInput onChange={changeLanguage} value={activeLng}>
                    <option value='en'>English</option>
                    <option value='fa'>فارسی</option>
                </SelectLngInput>
            </div>
        </div>
    );
};

export default LanguageMenu;
